import React, { Component } from 'react';
import MainLayout from "../common/MainLayout";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as pageActions from "../../actions/pages";
import {Redirect} from "react-router-dom";

class User extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageName: 'USER',
            userDet : window.localStorage.userDet?JSON.parse(window.localStorage.userDet):undefined
        };
    }
    componentDidMount() {

        let data = {"name" : this.state.pageName};
        this.props.setPage(data);
    }


    render() {
        if (!this.state.userDet) {
            return <Redirect to='/'/>;
        }
        return(
          <MainLayout pageName= {this.state.pageName} />
        )
    }

}
export default  withRouter(connect(null, {
    setPage : pageActions.setPage
})(User));


// WEBPACK FOOTER //
// ./src/components/user/User.js